import _ from "lodash";
import { columnBuilderMonths } from "./columnBuilderMonths";
import { formatNumber } from "../../../utils/function";
import {
  _COLORS,
  _HEADERS_NAME_INPUT_SALES,
  _INPUT_SALE_REGROUPING,
  _INPUT_SALES_OTHERS,
  _TAB_INPUT_SALES,
} from "../../../utils/constants";

export const columnBuilderVolume = (
  generatedColumns,
  tab,
  discountIncreases,
) => {
  generatedColumns.push({
    headerName: "",
    field: "type",
    rowGroup: true,
    hide: true,
    flex: 1,
  });
  generatedColumns.push({
    headerName: "",
    field: "sale",
    tooltipValueGetter: (params) => params.value,
    selectable: false,
    flex: 2,
    cellStyle: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  });

  columnBuilderMonths(generatedColumns, tab, discountIncreases);

  generatedColumns.push({
    headerName: _HEADERS_NAME_INPUT_SALES.TOTAL,
    headerClass: "total-header-col",
    field: "total",
    aggFunc: "sum",
    flex: 1,
    cellStyle: (params) => {
      if (
        params?.data?.type.includes("vide") ||
        params?.data?.type ===
          _INPUT_SALE_REGROUPING.EXTERNAL_CREDIT_DISCOUNT_GROUPING
      ) {
        return "";
      }

      return { backgroundColor: _COLORS.totalAgGrid };
    },
    valueFormatter: ({ node, data }) => {
      let unit = tab === "volume" ? "T" : "";
      if (
        data?.type.includes("vide") ||
        data?.type === _INPUT_SALE_REGROUPING.EXTERNAL_CREDIT_DISCOUNT_GROUPING
      ) {
        return "";
      }

      if (data !== undefined && data.sale.includes("Discount")) {
        unit = "%";
        return;
      }

      // when cell value change
      if (node?.parent?.aggData) {
        node.parent.aggData.total = 0; // Set to zero before calculation
        const totalPrent = Object.values(node?.parent?.aggData).reduce(
          (acc, value) => acc + (typeof value === "number" ? value : 0),
          0,
        );

        node.parent.aggData.total = totalPrent;
      }

      // calulate other lines
      if (data) {
        let total = 0;
        if (
          tab === "value" &&
          data.type !== _INPUT_SALE_REGROUPING.PRODUCT_GROUPING
        ) {
          total = Object.values(data.calculs).reduce(
            (acc, curr) => acc + curr,
            0,
          );
        } else {
          total = Object.values(data.months).reduce(
            (acc, curr) => acc + curr,
            0,
          );
        }
        data.totalLigne = total;

        return _.isNaN(total)
          ? `${0} ${unit}`
          : `${formatNumber(total)} ${unit}`;
      }

      // calulate total regroupement line
      if (node) {
        const total = Object.entries(node.aggData)
          .filter(([key]) => key !== "total")
          .reduce(
            (acc, [, value]) => acc + (typeof value === "number" ? value : 0),
            0,
          );

        return _.isNaN(total)
          ? `${0} ${unit}`
          : `${formatNumber(total)} ${unit}`;
      }
    },
  });

  generatedColumns.push({
    headerName: _HEADERS_NAME_INPUT_SALES.CASH,
    headerTooltip: "Avg Prices CASH",
    field: "cash",
    editable: (params) => {
      return params.data.type === _INPUT_SALE_REGROUPING.EXTERNAL_CASH_GROUPING;
    },
    type: "numericColumn",
    flex: 1,
    valueFormatter: (params) => {
      if (
        params?.data?.type === _INPUT_SALE_REGROUPING.EXTERNAL_CASH_GROUPING
      ) {
        return `${params.value ? params.value : 0}`;
      }

      return "";
    },
  });

  generatedColumns.push({
    headerName: _HEADERS_NAME_INPUT_SALES.CREDIT,
    headerTooltip: "Avg Prices CREDIT",
    field: "credit",
    cellStyle: (params) => {
      if (
        params?.data?.type ===
        _INPUT_SALE_REGROUPING.EXTERNAL_CREDIT_DISCOUNT_GROUPING
      ) {
        return { backgroundColor: "#FFD769" };
      }

      return "";
    },
    editable: (params) => {
      return (
        (params.data.type === _INPUT_SALE_REGROUPING.PMX_GROUPING &&
          params.data.sale !== _INPUT_SALES_OTHERS.DISCOUNT_PMX) ||
        (params.data.type === _INPUT_SALE_REGROUPING.DMX_GROUPING &&
          params.data.sale !== _INPUT_SALES_OTHERS.DISCOUNT_DMX) ||
        params.data.type === _INPUT_SALE_REGROUPING.BOLCK_GROUPING ||
        params.data.type === _INPUT_SALE_REGROUPING.DEPOT_GROUPING ||
        (params.data.type ===
          _INPUT_SALE_REGROUPING.EXTERNAL_CREDIT_DISCOUNT_GROUPING &&
          tab === _TAB_INPUT_SALES.VOLUME)
      );
    },
    type: "numericColumn",
    flex: 1,
    valueFormatter: (params) => {
      if (
        (params?.data?.type === _INPUT_SALE_REGROUPING.PMX_GROUPING &&
          params.data.sale !== _INPUT_SALES_OTHERS.DISCOUNT_PMX) ||
        (params?.data?.type === _INPUT_SALE_REGROUPING.DMX_GROUPING &&
          params?.data?.sale !== _INPUT_SALES_OTHERS.DISCOUNT_DMX) ||
        params?.data?.type === _INPUT_SALE_REGROUPING.BOLCK_GROUPING ||
        params?.data?.type === _INPUT_SALE_REGROUPING.DEPOT_GROUPING ||
        params?.data?.type ===
          _INPUT_SALE_REGROUPING.EXTERNAL_CREDIT_DISCOUNT_GROUPING ||
        params?.data?.type === _INPUT_SALE_REGROUPING.GCC_GROUPING ||
        params?.data?.type === _INPUT_SALE_REGROUPING.OTHER_GROUPING ||
        params?.data?.type === _INPUT_SALE_REGROUPING.UNSECURED_GROUPING ||
        params?.data?.type === _INPUT_SALE_REGROUPING.EXTERNAL_CREDIT_GROUPING
      ) {
        if (
          params?.data?.type === _INPUT_SALE_REGROUPING.EXTERNAL_CREDIT_GROUPING
        ) {
          if (params?.node) {
            const totalVolume = Object.values(
              params?.node?.data?.months,
            ).reduce((acc, curr) => acc + curr, 0);

            const totalValue = Object.values(
              params?.node?.data?.calculs,
            ).reduce((acc, curr) => acc + curr, 0);

            if (
              tab === _TAB_INPUT_SALES.VALUE &&
              !isNaN(totalVolume) &&
              totalVolume !== 0 &&
              !isNaN(totalValue) &&
              totalValue !== 0
            ) {
              return `${(totalValue / totalVolume).toFixed(2)}`;
            } else {
              return "";
            }
          }
        }
        if (
          params?.data?.type ===
          _INPUT_SALE_REGROUPING.EXTERNAL_CREDIT_DISCOUNT_GROUPING
        ) {
          return `${params.value ? params.value : 0} %`;
        }
        return `${params.value ? params.value : 0} `;
      }

      return "";
    },
    valueParser: (params) => parseFloat(params.newValue),
  });

  generatedColumns.push({
    headerName: _HEADERS_NAME_INPUT_SALES.DISCOUNT,
    headerTooltip: "Discount",
    field: "discount",
    editable: (params) => {
      return (
        params.data.type === _INPUT_SALE_REGROUPING.GCC_GROUPING ||
        params.data.type === _INPUT_SALE_REGROUPING.OTHER_GROUPING ||
        params.data.type === _INPUT_SALE_REGROUPING.UNSECURED_GROUPING
      );
    },
    type: "numericColumn",
    flex: 1,
    valueFormatter: (params) => {
      if (params?.data?.type.includes("vide")) {
        return "";
      }
      return params.value !== null
        ? params?.data?.type === _INPUT_SALE_REGROUPING.GCC_GROUPING ||
          params?.data?.type === _INPUT_SALE_REGROUPING.OTHER_GROUPING ||
          params?.data?.type === _INPUT_SALE_REGROUPING.UNSECURED_GROUPING
          ? `${params.value ? params.value : 0} %`
          : params.value
        : "";
    },
    valueParser: (params) => parseFloat(params.newValue),
  });

  return generatedColumns;
};
